import React, { useState } from 'react';
import axios from 'axios';
import ServiceSelection from '../components/service-selection';
import contact from '../assets/contact.svg';
import {useNavigate } from 'react-router-dom';
import {Reveal,Zoom} from 'react-reveal'
const ContactForm = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    companyName: '',
    description: '',
    selectedServices: [], 
  });

  const [isLoading, setIsLoading] = useState(false); 

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true); 
      const response = await axios.post('https://portfolio-5auy.onrender.com/submit-form', formData);
      console.log(response.data);

  
      setFormData({
        name: '',
        email: '',
        companyName: '',
        description: '',
        selectedServices: [], 
      });
      setIsLoading(false); 
      navigate("/success")
    } catch (error) {
      console.error(error);
      setIsLoading(false); 
    }
  };

  const handleSelectedServices = (selectedServices) => {
    setFormData({ ...formData, selectedServices });
  };

  return (
    <div className="bg-black min-h-screen">
     <Zoom>
      <h1 className="text-orange-default text-3xl font-bold text-center md:pt-20 lg:text-start py-10 lg:pl-80 lg:pt-20">
        CONTACT ME
      </h1>
      </Zoom>
      <Reveal>
      <div className="flex justify-center">
        {/* Form Container */}
        <div className="flex flex-col md:flex-row mx-4 rounded-lg">
          <div className="hidden bg-black lg:flex lg:w-1/2 lg:pt-48">
          <img src={contact} alt="reach me" className='w-full h-64' />
          </div>
          <div className="w-full px-6 lg:bg-grey-default lg:w-1/2 lg:mt-2 sm:p-20 p-4 md:p-8 mt-4 mb-20 md:mt-12 lg:mb-20 lg:mr-20">
          <ServiceSelection onServiceSelect={handleSelectedServices} />
            <div className="mt-6 mb-4">
              <h1 className="text-2xl font-bold text-orange-default">YOUR DETAILS</h1>
              <p className="text-md font-semibold text-gray-300">Fill this form</p>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="mt-4">
                <div className="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0">
                  <input
                    type="text"
                    className="w-full bg-grey-default text-white border border-orange-300 rounded-lg px-4 py-2 focus:outline-none"
                    placeholder="Name"
                    required="true"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <input
                    type="email"
                    className="w-full border bg-grey-default text-white border-gray-300 rounded-lg px-4 py-2 focus:outline-none"
                    placeholder="Email"
                    required="true"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </div>
                <input
                  type="text"
                  className="w-full mt-4 bg-grey-default text-white border border-gray-300 rounded-lg px-4 py-2 focus:outline-none"
                  placeholder="Company Name"
                  required="tur"
                  value={formData.companyName}
                  onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                />
                <textarea
                  className="w-full mt-4 bg-grey-default text-white border border-gray-300 rounded-lg px-4 py-2 focus:outline-none"
                  placeholder="Description"
                  rows="4"
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
                <button
                  type="submit"
                  className={`bg-orange-default p-2 mt-4 rounded-md text-white font-medium ${
                    isLoading ? 'animate-pulse' : '' 
                  }`}
                  disabled={isLoading}
                >
                  {isLoading ? 'Sending...' : 'Send Message'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      </Reveal>
    </div>
  );
};

export default ContactForm;


